import Component from './AccessUserEditLinkContainer'

export default Component
